import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { Button } from '@ui/components';
import { FC } from 'react';

interface ActiveServicePreviewProps {
  data: {
    value: string;
    key: string;
  }[];
  onEdit: () => void;
  canNotEdit?: boolean;
}

export const ActiveServicePreview: FC<ActiveServicePreviewProps> = ({
  canNotEdit,
  onEdit,
  data,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-12">
      <div className="col-span-10 space-y-2">
        {data.map((item) => (
          <div className="flex gap-1" key={item.key}>
            <Typography className="text-weak">{t(item.key)}:</Typography>
            <Typography className="font-medium">{item.value}</Typography>
          </div>
        ))}
      </div>

      {!canNotEdit && (
        <div className="col-span-2 text-right">
          <Button className="max-w-full" onClick={onEdit}>
            <span className="truncate">{t('COMPANY_POLICY.EDIT')}</span>
          </Button>
        </div>
      )}
    </div>
  );
};
